import { Type } from 'class-transformer'
import { User } from '@core/entities/user'

export class Recipients {
  @Type(() => User)
  users: Array<User>

  authGroups: Array<{
    id: number
    name: string
  }>

  emailAddresses: string[]
}
